<template>
  <div class="_base-payment-upload-card my-4 mt-8">
    <v-card class="px-4 py-8 d-flex flex-column flex-sm-row justify-center align-center">
      <img
        class="mb-4 mb-sm-0"
        src="/svg/bank/kbank.svg"
        alt="KBank Logo"
        width="100">
      <div class="d-flex flex-column pl-4 justify-center">
        <div>
          โอนเข้าบัญชีธนาคาร <span class="font-weight-bold">กสิกรไทย</span>
        </div>
        <div class="pt-2">
          สาขา <span class="font-weight-bold">เซ็นทรัลพระราม 9</span>
        </div>
        <div class="pt-2">
          ชื่อบัญชี <span class="font-weight-bold">บจก. เซลสุกิ</span>
        </div>
        <div class="pt-2">
          เลขที่บัญชี <span class="font-weight-bold">055-1-27809-3</span>
        </div>
      </div>
    </v-card>

    <div class="mt-4 grey--text text-center">
      (บัญชีสำหรับชำระค่าบริการ LINE Official Account เท่านั้น)
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasePaymentUploadCard'
}
</script>
